import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=b968fe56&"
import script from "./CatalogList.vue?vue&type=script&lang=ts&"
export * from "./CatalogList.vue?vue&type=script&lang=ts&"
import style0 from "../../assets/css/components/list.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports